import {ChangeDetectionStrategy, Component, HostBinding, input} from '@angular/core';
import {Image} from "primeng/image";

@Component({
  selector: 'homey-lottery-list-item-empty',
    imports: [
        Image
    ],
  templateUrl: './lottery-list-item-empty.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LotteryListItemEmptyComponent {
  @HostBinding('class') readonly hostClass = 'flex items-center gap-2 relative';
  public readonly title = input.required<string>();
  public readonly description = input.required<string>();
}
